// extracted by mini-css-extract-plugin
export default {"wrapper":"LoadingSkeleton_wrapper__O5Eme","row":"LoadingSkeleton_row__OiY79","cell":"LoadingSkeleton_cell__1SjE6","shimmer":"LoadingSkeleton_shimmer__IHHVc"};